import { render, staticRenderFns } from "./AlarmTableCom.vue?vue&type=template&id=33d5ad6a&scoped=true"
import script from "./AlarmTableCom.vue?vue&type=script&lang=js"
export * from "./AlarmTableCom.vue?vue&type=script&lang=js"
import style0 from "./AlarmTableCom.vue?vue&type=style&index=0&id=33d5ad6a&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "33d5ad6a",
  null
  
)

export default component.exports